import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const TagSnippetWidgetAsyncComponent = AsyncComponent(async () => import('./tag-snippet-widget' /* webpackChunkName: "tag-snippet-widget" */ ));

export const TagSnippetWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper onWidgetVisible={props.onWidgetVisible}>
      <TagSnippetWidgetAsyncComponent {...props}/>
  </ErrorBoundaryWrapper>
};
